import { kuesionerData } from '../helpers/kuesioner';

/**
 * Calculates the age in total months from a given date of birth to today.
 * @param {Date} dob - The date of birth.
 * @returns {number} The total age in months.
 */
export const getAgeInMonths = (dob) => {
    const today = new Date();
    let months = (today.getFullYear() - dob.getFullYear()) * 12;
    months -= dob.getMonth();
    months += today.getMonth();
    // If the birth date of the month is after today's date of the month, subtract one month.
    if (today.getDate() < dob.getDate()) {
        months--;
    }
    return months <= 0 ? 0 : months;
};

/**
 * Determines the correct KPSP screening schedule key based on age in months.
 * @param {number} ageInMonths - The child's age in months.
 * @returns {string|null} The key for the kuesionerData.kpsp object (e.g., "3", "6", "9") or null if out of range.
 */
export const getKpspScheduleKey = (ageInMonths) => {
    const schedules = Object.keys(kuesionerData.kpsp).map(Number).sort((a, b) => a - b);
    
    let applicableSchedule = null;
    for (const scheduleAge of schedules) {
        if (ageInMonths >= scheduleAge) {
            applicableSchedule = scheduleAge;
        } else {
            break;
        }
    }

    return applicableSchedule ? String(applicableSchedule) : null;
};
